import { useEffect } from 'react';

import { TrimStyle } from 'src/modules/designStudio/types';

import { FeatureCategories } from '../../../constants';
import { Building, UpdateStylesEvent } from '../../../machines/building';

interface TrimProps {
  updateStyles: (evt: UpdateStylesEvent) => void;
  config: TrimStyle;
  building: Building;
}

/*
  This component does NOT render anything. It uses react's reconciliation
  algorithm to update the model when the design configuration changes.
*/
export function TrimConfig(props: TrimProps) {
  const {
    config: { color, textureId },
    updateStyles,
    building,
  } = props;

  useEffect(() => {
    if (!building) return;

    updateStyles({
      type: 'UPDATE_STYLES',
      category: FeatureCategories.TRIM,
      update: {
        color,
        textureId,
      },
    });
  }, [building, color, textureId, updateStyles]);

  return null;
}
